<template>
  <div class="v-wrap">
    <div>

      <filter-presets
        :searchPresets="searchPresets"
        :crtPreset="crtPreset"
        @updateCrtPreset="updateCrtPreset"
        @searchByPreset="searchByPreset"
      />

      <section class="v-diamondFilter">
        <form v-on:submit.prevent>
          <filter-accordion :isOpenedDefault="true"
           :labelDefault="$t('Main.basic_filter.label')"
           >
            <div class="v-formBlock">
              <h4 class="v-formBlock__head">{{ $t('Main.basic_filter.shape.head') }}</h4>

              <ul class="v-selectShapeList">
                <li v-for="s in shapes" :key="s" class="v-selectShapeList__item">
                  <label class="v-selectShapeList__label">
                    <input
                      type="radio"
                      class="v-selectShapeList__input"
                      :disabled="isLoading"
                      @change="onFormChange"
                      v-model="selectedShape"
                      name="shape"
                      :value="s">
                    <div class="v-selectShapeList__button">
                      <div v-if="s" class="v-selectShapeList__imgWrap">
                        <svg :title="shapeLabel(s)" width="25" height="25" viewBox="0 0 110 110">
                          <use
                            x="0" y="0" width="110" height="110"
                            :href="'#diamond_symbol_' + s"
                            stroke-width="2"
                          ></use>
                        </svg>
                      </div>
                      <div class="v-selectShapeList__name">
                        <span v-if="s">{{ shapeLabel(s) }}</span>
                        <span v-else>{{ $t('Main.basic_filter.shape.all') }}</span>
                      </div>
                    </div>
                  </label>
                </li>
              </ul>
            </div>

            <div class="v-formBlock" v-if="showPrice">
              <h4 class="v-formBlock__head">{{ $t('Main.basic_filter.price.head') }}</h4>

              <!-- text -->
              <div class="v-inputRangeBlock">
                <div class="v-inputRangeBlock__item -price">
                  <input
                    type="text"
                    class="v-inputText"
                    v-model.number="minPrice"
                    :disabled="isLoading"
                    @change="onFormChange"
                  />
                </div>
                <span class="v-inputRangeBlock__wavedash">〜</span>
                <div class="v-inputRangeBlock__item -price">
                  <input
                    type="text"
                    class="v-inputText"
                    v-model.number="maxPrice"
                    :disabled="isLoading"
                    @change="onFormChange"
                  />
                </div>
              </div>

              <multi-range-slider
                name="price"
                :min="inputMinPrice"
                :max="inputMaxPrice"
                :minValue="minPrice"
                :maxValue="maxPrice"
                @changeMinValue="updateMinPrice"
                @changeMaxValue="updateMaxPrice"
                @onFormChange="onFormChange"
              />

            </div>

            <div class="v-formBlock">
              <h4 class="v-formBlock__head">{{ $t('Main.basic_filter.carat.head') }}</h4>

              <!-- text -->
              <div class="v-inputRangeBlock">
                <div class="v-inputRangeBlock__item -carat">
                  <input
                    type="text"
                    class="v-inputText"
                    v-model.number="minWeight"
                    :disabled="isLoading"
                    @change="onFormChange"
                  />
                </div>
                <span class="v-inputRangeBlock__wavedash">〜</span>
                <div class="v-inputRangeBlock__item -carat">
                  <input
                    type="text"
                    class="v-inputText"
                    v-model.number="maxWeight"
                    :disabled="isLoading"
                    @change="onFormChange"
                  />
                </div>
              </div>

              <multi-range-slider
                name="carat"
                :min="inputMinWeight"
                :max="inputMaxWeight"
                :minValue="minWeight"
                :maxValue="maxWeight"
                @changeMinValue="updateMinWeight"
                @changeMaxValue="updateMaxWeight"
                @onFormChange="onFormChange"
              />
            </div>
          </filter-accordion>

          <filter-accordion :labelDefault="$t('Main.all_filter.label')">
            <div class="v-formBlock">
              <h4 class="v-formBlock__head">{{ $t('Main.all_filter.color.head') }}</h4>

              <div class="v-inputRangeBlock">
                <div class="">
                  <select v-model="minColor" @change="onFormChange" class="v-inputText">
                    <option v-for="color in colors" :key="color">{{ color }}</option>
                  </select>
                </div>
                <span class="v-inputRangeBlock__wavedash">〜</span>
                <div class="">
                  <select v-model="maxColor" @change="onFormChange" class="v-inputText">
                    <option v-for="color in colors" :key="color">{{ color }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="v-formBlock">
              <h4 class="v-formBlock__head">{{ $t('Main.all_filter.clarity.head') }}</h4>

              <div class="v-inputRangeBlock">
                <div class="">
                  <select v-model="minClarity" @change="onFormChange" class="v-inputText">
                    <option v-for="clarity in clarities" :key="clarity">{{ clarity }}</option>
                  </select>
                </div>
                <span class="v-inputRangeBlock__wavedash">〜</span>
                <div class="">
                  <select v-model="maxClarity" @change="onFormChange" class="v-inputText">
                    <option v-for="clarity in clarities" :key="clarity">{{ clarity }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="v-formBlock">
              <h4 class="v-formBlock__head">{{ $t('Main.all_filter.cut.head') }}</h4>

              <div class="v-inputRangeBlock">
                <div class="">
                  <select v-model="minCut" @change="onFormChange" class="v-inputText">
                    <option v-for="cut in cutGrades" :key="cut" :value="cut">{{ cutGradeLabel(cut) }}</option>
                  </select>
                </div>
                <span class="v-inputRangeBlock__wavedash">〜</span>
                <div class="">
                  <select v-model="maxCut" @change="onFormChange" class="v-inputText">
                    <option v-for="cut in cutGrades" :key="cut" :value="cut">{{ cutGradeLabel(cut) }}</option>
                  </select>
                </div>
              </div>
            </div>
          </filter-accordion>
        </form>
      </section>
    </div>

    <div>
      <tag-description
        v-if="tagDescription && Object.keys(tagDescription).length"
        :tagDescription="tagDescription"
      />
      <diamond-list
        :diamonds="diamonds"
        :shapeTranslations="shapeTranslations"
        :cutGradeTranslations="cutGradeTranslations"
        :shapeLabel="shapeLabel"
        :cutGradeLabel="cutGradeLabel"
        :showPrice="showPrice"
      />
    </div>
  </div>
</template>

<script>
import { Http } from '../../../../http'
import FilterAccordion from './FilterAccordion.vue'
import FilterPresets from './FilterPresets.vue'
import DiamondList from './DiamondList.vue'
import TagDescription from './TagDescription.vue'
import MultiRangeSlider from './MultiRangeSlider.vue'

export default {
  name: 'Main',

  components: { DiamondList, FilterAccordion, FilterPresets, TagDescription, MultiRangeSlider },

  data () {
    return {
      isLoading: true,
      diamonds: [],
      shapes: [],
      colors: [],
      clarities: [],
      cutGrades: [],
      selectedShape: 'round',
      shapeTranslations: [],
      cutGradeTranslations: [],
      crtPreset: '',
      searchPresets: {},
      // デフォルト価格
      minPrice: 90000,
      maxPrice: 300000,
      // スライダーの価格幅
      inputMinPrice: 90000,
      inputMaxPrice: 20000000,
      // デフォルトカラット
      minWeight: 0.100,
      maxWeight: 0.500,
      // スライダーのカラット幅
      inputMinWeight: 0.100,
      inputMaxWeight: 5.000,
      //
      tagDescription: null,
      minColor: null,
      maxColor: null,
      minClarity: null,
      maxClarity: null,
      minCut: null,
      maxCut: null,
      showPrice: false,
    }
  },

  watch: {
    '$route': {
      immediate: true,
      deep: true,
      handler (to, from) {
        if (to.query['shape']) {
          this.selectedShape = to.query['shape'];
        }
        if (to.query['min_price'] && to.query['max_price']) {
          this.minPrice = parseFloat(to.query['min_price']);
          this.maxPrice = parseFloat(to.query['max_price']);
        }
        if (to.query['min_weight'] && to.query['max_weight']) {
          this.minWeight = parseFloat(to.query['min_weight']);
          this.maxWeight = parseFloat(to.query['max_weight']);
        }
        if (to.query['min_color'] && to.query['max_color']) {
          this.minColor = to.query['min_color'];
          this.maxColor = to.query['max_color'];
        }
        if (to.query['min_clarity'] && to.query['max_clarity']) {
          this.minClarity = to.query['min_clarity'];
          this.maxClarity = to.query['max_clarity'];
        }
        if (to.query['min_cut'] && to.query['max_cut']) {
          this.minCut = to.query['min_cut'];
          this.maxCut = to.query['max_cut'];
        }
      },
    },
  },

  methods: {
    shapeLabel (shape) {
      if (this.shapeTranslations.length) {
        const translation = this.shapeTranslations.find((t) => {
          return t.shape === shape
        });
        return translation.label;
      } else {
        return shape
      }
    },

    cutGradeLabel (cut_grade) {
      if (cut_grade && this.cutGradeTranslations.length) {
        const translation = this.cutGradeTranslations.find((t) => {
          return t.cut_grade === cut_grade
        });
        return translation.label;
      } else {
        return cut_grade
      }
    },

    searchByPreset (values) {
      this.selectedShape = values.selectedShape;
      this.minPrice = values.minPrice;
      this.maxPrice = values.maxPrice;
      this.minWeight = values.minWeight;
      this.maxWeight = values.maxWeight;
      this.minColor = values.minColor;
      this.maxColor = values.maxColor;
      this.minClarity = values.minClarity;
      this.maxClarity = values.maxClarity;
      this.minCut = values.minCut;
      this.maxCut = values.maxCut;

      // onFormChange
      this.pushRoute();
      this.getDiamonds();
    },

    onFormChange () {
      this.crtPreset = '';
      this.pushRoute();
      this.getDiamonds();
    },

    queryPath () {
      return {
        path: '/',
        query: {
          'shape': this.selectedShape,
          'min_price': this.minPrice,
          'max_price': this.maxPrice,
          'min_weight': this.minWeight,
          'max_weight': this.maxWeight,
          'min_color': this.minColor,
          'max_color': this.maxColor,
          'min_clarity': this.minClarity,
          'max_clarity': this.maxClarity,
          'min_cut': this.minCut,
          'max_cut': this.maxCut,
          'locale': this.$route.query.locale,
        },
      }
    },

    getDiamonds () {
      this.isLoading = true;
      const url = `/api/collections/diamonds`;
      const queryParams = this.$router.resolve(this.queryPath()).resolved.fullPath;

      return Http.get(url + queryParams)
        .then(response => {
          this.isLoading = false;

          if (response.data && response.data.diamonds) {
            this.diamonds = response.data.diamonds;
          }

          if (response.data && response.data.tag_description) {
            this.tagDescription = response.data.tag_description;
          } else {
            this.tagDescription = null;
          }

          if (response.data && response.data.show_price == "false") {
            this.showPrice = false
          } else {
            this.showPrice = true
          }

          this.shapes = response.data.form.shapes;
          this.shapeTranslations = response.data.shape_translations;
          this.cutGradeTranslations = response.data.cut_grade_translations;
          this.colors = response.data.form.colors;
          this.clarities = response.data.form.clarities;
          this.cutGrades = response.data.form.cut_grades;
          this.searchPresets = response.data.search_presets;
          if (response.data.locale) { this.$i18n.locale = response.data.locale }
        })
    },

    pushRoute () {
      this.$router.push(this.queryPath()).catch(err => {})
    },

    updateMinPrice (value) {
      this.minPrice = value;
    },

    updateMaxPrice (value) {
      this.maxPrice = value;
    },

    updateMinWeight (value) {
      this.minWeight = value;
    },

    updateMaxWeight (value) {
      this.maxWeight = value;
    },

    updateCrtPreset (str) {
      this.crtPreset = str;
    },
  },

  created () {
    this.getDiamonds();
  },
}
</script>

<style lang="scss" scoped>
  .v-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;

    @media screen and (min-width: 1200px) {
      display: grid;
      grid-template-columns: 375px 1fr;
      grid-gap: 30px;
      margin: 30px auto;
    }

    @media screen and (min-width: 1600px) {
      max-width: 1600px;
    }
  }

  .v-formBlock {
    &+& {
      margin-top: 1rem;
    }

    &__head {
      font-size: 10px;
    }
  }

  // select shape
  .v-selectShapeList {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;

    &__label {
      display: block;
      position: relative;
      height: 100%;
      cursor: pointer;
    }

    // アクセシビリティのため、display noneしない
    &__input {
      opacity: 0;
      position: absolute;
    }

    &__button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      border: 1px solid #f1f1f1;
    }

    &__input:disabled + &__button {
      opacity: .5;
      background: #f1f1f1;
    }

    &__input:checked + &__button {
      border-color: #2a475a;
      color: #2a475a;
      background: #fbfbfb;
    }

    &__imgWrap {
      margin-top: 5px;
    }

    &__name {
      font-size: 10px;
    }
  }

  // input price/carat text
  .v-inputRangeBlock {
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: 10px;
    align-items: center;

    &__item {
      position: relative;

      &::before {
        position: absolute;
        top: 0;
        bottom: 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-size: 10px;
        opacity: .8;
      }

      &.-price::before {
        content: "¥";
        left: 10px;
      }

      &.-carat::before {
        content: "ct";
        right: 8px;
      }
    }
  }

  .v-inputText {
    margin: 0;
    font-family: inherit;
    flex: 1;
    border-radius: 4px 0 0 4px;
    border: 1px solid var(--border-color);
    padding: 10px 20px;
    line-height: 1.2;
    width: 100%;
    text-align: center;
    font-size: 16px;
  }
</style>
